import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@material-ui/core';
import theme from '../utilities/theme';
import themeBZ from '../utilities/themeBZ';
import themePP from '../utilities/themePP';
import themeIL from '../utilities/themeIL';
import themeKS from '../utilities/themeKS';
import {
  StylesProvider,
  createGenerateClassName,
} from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  whiteIcon: {
    color: '#FFF',
  },
  root: {
    top: 50,
    pointerEvents: 'initial !important',
  },
}));

const Wrapper = ({ children, overrideService, seed, productionPrefix }) => {
  const generateClassName = createGenerateClassName({
    productionPrefix: productionPrefix,
    seed: seed,
  });

  let appTheme = theme();
  const classes = useStyles();

  if (typeof service !== 'undefined') {
    if (service === 'bz') {
      appTheme = themeBZ();
    }
    if (service === 'pp') {
      appTheme = themePP();
    }
    if (service === 'il') {
      appTheme = themeIL();
    }
    if (service === 'ks') {
      appTheme = themeKS();
    }
  }

  if (overrideService !== '') {
    if (overrideService === 'bz') {
      appTheme = themeBZ();
    }
    if (overrideService === 'pp') {
      appTheme = themePP();
    }
    if (overrideService === 'il') {
      appTheme = themeIL();
    }
    if (overrideService === 'ks') {
      appTheme = themeKS();
    }
  }
  const notistackRef = React.createRef();

  const onClickDismiss = (key) => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={appTheme}>
        <SnackbarProvider
          ref={notistackRef}
          classes={{ root: classes.root }}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          preventDuplicate
          autoHideDuration={3600000}
          action={(key) => {
            return (
              <IconButton
                onClick={() => onClickDismiss(key)}
                className={classes.whiteIcon}
              >
                <CloseIcon fontSize='small' />
              </IconButton>
            );
          }}
        >
          <Router>{children}</Router>
        </SnackbarProvider>
      </ThemeProvider>
    </StylesProvider>
  );
};

Wrapper.propTypes = {
  overrideService: PropTypes.string,
  productionPrefix: PropTypes.string.isRequired,
  seed: PropTypes.string.isRequired,
};

Wrapper.defaultProps = {
  overrideService: '',
};

export default Wrapper;
